/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import React from 'react';
import * as _ from 'lodash';
import { injectIntl } from 'react-intl';

import './PolicyRoutes.scss';

import PolicyDocumentTemplate from './PolicyDocumentTemplate';
import { PolicyName } from '../../../../models/PolicyModel';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { useUser } from '../../../hooks/useUser';
import { useLists } from '../../../hooks/useLists';
import { usePolicy } from '../../../hooks/usePolicy';
import { useUIState } from '../../../hooks/useUIState';

const getDocumentNameFromUrl = (intl, pathname) => {
  const policyNameFromPathname = _.last(pathname.split('/'));
  switch (policyNameFromPathname) {
    case _.last(intl.formatMessage({ id: 'legal.privacyPolicy.URL' }).split('/')):
      return PolicyName.PRIVACY;
    case _.last(intl.formatMessage({ id: 'legal.termsOfService.URL' }).split('/')):
      return PolicyName.TERMS;
    case _.last(intl.formatMessage({ id: 'legal.groupConsent.URL' }).split('/')):
      return PolicyName.GROUP_CONSENT;
    case _.last(intl.formatMessage({ id: 'legal.cookiePolicy.URL' }).split('/')):
      return PolicyName.COOKIE;
    case _.last(intl.formatMessage({ id: 'legal.acknowledgements.URL' }).split('/')):
      return PolicyName.ACKNOWLEDGEMENTS;
    case _.last(intl.formatMessage({ id: 'legal.informedConsent.URL' }).split('/')):
      return PolicyName.INFORMED_CONSENT;
    default:
      return null;
  }
};
const PolicyRoutes = injectIntl((props) => {
  const [{ localeList }] = useLists();
  const [{ preferredLanguageCode }, userActions] = useUser();
  const [policyState, policyActions] = usePolicy();
  const [, uiActions] = useUIState();

  const [documentName, setDocumentName] = React.useState('');

  React.useEffect(() => {
    const urlLanguageCode = _.get(props, 'match.params.languageCode', '');
    const defaultLanguageCode = urlLanguageCode || preferredLanguageCode;
    const defaultLocale = localeList.filter(l => l.language_code === defaultLanguageCode)[0];
    userActions.setLocale(defaultLocale);
  }, []);

  React.useEffect(() => {
    if (documentName) { return; }
    if (props.intl.locale !== preferredLanguageCode) { return; }

    const pathname = props.location.pathname;
    const docName = getDocumentNameFromUrl(props.intl, pathname);
    if (docName) {
      setDocumentName(docName);
    }
  }, [policyState.isLoaded, preferredLanguageCode]);

  React.useEffect(() => {
    if (!documentName) { return; }
    const policyData = policyActions.getPolicy(documentName, null, preferredLanguageCode);
    if (!policyData) return;

    uiActions.setWindowTitle([
      { id: 'app.backpack.name' },
      ' – ',
      policyData.title,
    ]);
  }, [policyState.isLoaded, preferredLanguageCode]);

  return (
    <div className="page-policies bkgd-color-gsLightest">
      <Header />

      <PolicyDocumentTemplate documentName={documentName} languageCode={preferredLanguageCode} />

      <Footer />
    </div>
  );
});

export default PolicyRoutes;
